import { createSelector } from '@ngrx/store';
import { selectPnrState } from '../reducers/pnr.reducer';

export const getAdultsIncharge = createSelector(
  selectPnrState,
  (state) => state.infantReasignationControl.adultsInCharge
);
